import { z } from 'zod';
import { AppointmentConclusionSchema } from './AppointmentConclusionSchema';
import { AppointmentStatus } from '../enums/AppointmentStatus';
import { IObject } from '../IObject';
import { AppointmentTranscriptionSchema } from './AppointmentTranscriptionSchema';
import {
  dateValidation,
  emailValidation,
  coerceNumber,
} from '../../validation';

export const AppointmentDataSchema = z.object({
  shortId: z.string().optional(), // only by Platform, not sent from Healee
  fhirId: z.string().optional(), // only by Platform, not sent from Healee
  caseId: z.string().optional(),

  status: z.enum(AppointmentStatus),
  services: z.array(coerceNumber(z.number())).optional(),
  patientEmail: emailValidation().optional(),
  patientFhirId: z.string().optional(),
  date: dateValidation().nullish(),
  previousAppointmentDates: z
    .array(
      z.object({
        date: dateValidation().nullish(),
        rescheduled: dateValidation().optional(),
        by: z.string().optional(),
      }),
    )
    .optional(),
  doctor: z.string().max(150).optional(),
  // fhirId (GUID) of the clinician. Preferred over the `doctor` name when
  // classifying an appointment as expert- vs professional-completed.
  doctorId: z.string().nullish(),
  conclusion: AppointmentConclusionSchema.optional(),
  cancelledAt: dateValidation().optional(),

  followedUp: z.boolean().optional(),
  noShow: z.boolean().optional(),

  // storage references
  transcriptions: z.array(AppointmentTranscriptionSchema).optional(),
});

export const AppointmentSchema = AppointmentDataSchema.extend({
  id: z.string().min(1),
  createdAt: dateValidation(),
});

export type AppointmentData = z.infer<typeof AppointmentDataSchema>;

export type Appointment = IObject.HasIdTimestamped<
  z.infer<typeof AppointmentSchema>
>;
